import React from "react"
import { RangeCalendar } from "../MultiRangeCalendar.domain"
import { useIntl } from "react-intl"

interface DefinedRangeProps {
	definedRangeFunction: () => RangeCalendar[]
	label: string
	onChange: (rangeCalendar: RangeCalendar[]) => void
	isSelected: boolean
	ranges: RangeCalendar[]
}

const DefinedRange: React.FC<DefinedRangeProps> = (props) => {
	const { definedRangeFunction, label, isSelected, onChange } = props
	const intl = useIntl()

	return (
		<div
			data-testid="defined-range"
			className={isSelected ? "selected" : ""}
			onClick={() => onChange(definedRangeFunction())}
		>
			{intl.formatMessage({ id: label })}
		</div>
	)
}

export default DefinedRange
